// extracted by css-extract-rspack-plugin
export default {"wrapper":"_8c843609","disabled":"_1b6de9aa","day":"_6a36c026","selected":"_5fdb8293","today":"_a9afd0fd","outside":"_24de172f"};